import './Logo.scss';

import React from 'react';

function Logo() {
  return (
    <div className="d-flex align-items-center">
      <img
        className="c-logo__image"
        src="/images/rocket.png"
        alt="Sales Cockpit"
      />
      <img className="c-logo__image" src="/images/logo.png" alt="ZMS" />
      <span className="ml-2">Sales Cockpit</span>
    </div>
  );
}

Logo.propTypes = {};

export default Logo;
